import React, { useMemo } from 'react';
import Modal from 'react-modal';

import IconAddlistOrange from '../../assets/images/common/icon-addlist-orange.svg';

import { Prefecture, City } from '../../types/api/MasterPrefectureApiType';
import { ChangeFieldItemInput } from '../../types/common/EstimateInquiryType';
import { MODEL_COUNT } from '../../types/common/EstimationType';

import { FieldItemInput } from '../EditDeviceList/FieldItemInput';
import { useAppSelector } from '../../store/hooks';

type AddDeviceModalProps = {
    openState: boolean;
    setOpenState: (value: boolean) => void;
    modalItems: ChangeFieldItemInput;
    setModalItems: (value: ChangeFieldItemInput) => void;
    addButtonFunc: () => void;
};

export const AddDeviceModal: React.FC<AddDeviceModalProps> = ({
    openState,
    setOpenState,
    modalItems,
    setModalItems,
    addButtonFunc,
}) => {
    // 都道府県マスタ取得
    const masterPrefecture = useAppSelector((s) => s.MasterPrefecture);
    // select 都道府県
    const prefectureList = useMemo<Array<Prefecture>>(() => masterPrefecture.prefecture, []);
    // select 市
    const cityList = useMemo<Array<City>>(() => masterPrefecture.city, []);

    return (
        <Modal
            isOpen={openState}
            onAfterOpen={() => setOpenState(true)}
            onRequestClose={() => setOpenState(false)}
            className={'modal-card device-add'}
            id={'modal-first'}
            overlayClassName={'modal-overlay'}
            ariaHideApp={false}
            portalClassName={'AddDeviceModalReactModalPortal'}
        >
            <header className='modal-card-head'>
                <p className='modal-card-title'>機器情報編集</p>
                <button className='delete' aria-label='close' onClick={() => setOpenState(false)}>
                    <span>CLOSE</span>
                </button>
            </header>
            <section className='modal-card-body device-add-body'>
                <div className='edit-device-list-edit-row'>
                    <h3>設置場所</h3>
                    <FieldItemInput
                        inputData={modalItems}
                        setInputData={setModalItems}
                        prefectureList={prefectureList}
                        cityList={cityList}
                    />
                    <div className='select vol'>
                        <select
                            onChange={(e) => setModalItems({ ...modalItems, unitCount: e.target.value })}
                            value={modalItems.unitCount}
                        >
                            {MODEL_COUNT.map((num) => (
                                <option key={`edit-row-unitCount-${num.value}`} value={num.value}>
                                    {num.caption}
                                </option>
                            ))}
                        </select>
                    </div>
                    <input
                        type='text'
                        onChange={(e) => setModalItems({ ...modalItems, freeText: e.target.value })}
                        value={modalItems.freeText}
                        className='edit-row-freeword'
                        placeholder='機器に関する備考を入力してください。　例：検証環境用'
                    />
                </div>
                <div className='edit-device-list-add-buttons'>
                    <dd>
                        <button className='button is-small addlist' onClick={addButtonFunc}>
                            見積り機器に追加
                            <span className='icon is-small is-right'>
                                <img src={IconAddlistOrange} alt='' />
                            </span>
                        </button>
                    </dd>
                </div>
            </section>
        </Modal>
    );
};
